import { render, staticRenderFns } from "./EventContest.vue?vue&type=template&id=6af0aebe&scoped=true"
import script from "./EventContest.vue?vue&type=script&lang=ts"
export * from "./EventContest.vue?vue&type=script&lang=ts"
import style0 from "./EventContest.vue?vue&type=style&index=0&id=6af0aebe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af0aebe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af0aebe')) {
      api.createRecord('6af0aebe', component.options)
    } else {
      api.reload('6af0aebe', component.options)
    }
    module.hot.accept("./EventContest.vue?vue&type=template&id=6af0aebe&scoped=true", function () {
      api.rerender('6af0aebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/EventContest.vue"
export default component.exports